"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.memoizedGroupBySelector = exports.genericGroupBy = void 0;
const mem = require("mem");
// Group an object of { key: T } by a keyof T.
// Any T that don't have a value for the `key` argument will be placed in
// `undefined`.
exports.genericGroupBy = (key, state) => {
    return Object.values(state).reduce((acc, curr) => {
        const groupKey = curr[key];
        const existingValues = acc[groupKey] || [];
        existingValues.push(curr);
        return Object.assign(Object.assign({}, acc), { [groupKey]: existingValues });
    }, {});
};
// Memoized version of this function
exports.memoizedGroupBySelector = mem(exports.genericGroupBy);
//# sourceMappingURL=selector.js.map